module.exports = __webpack_public_path__ + "img/ateam.a6c2ce13.png";